<template>
<div class="containers">
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol sm="5" class="pr-2">
                <input type="text" v-model="filter.organisasi" placeholder="Organisasi" class="inputs-form form-control"/>
            </CCol>
            <CCol sm="5" class="pr-2">
                <input type="number" v-model.number="filter.tahun" placeholder="Tahun" class="inputs-form form-control"/>
            </CCol>
            <CCol sm="2">
                <CButton style="float:right" @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                <CButton style="float:right; margin-right: 8px;" @click="openModalAdd()" type="button" class="btn btn-primary">Tambah</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6"></CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:right"/>
            </CCol>
        </CRow>
    </div>

    <!-- We will build a custom table so we can add edit buttons easily -->
    <div style="padding: 0 24px 24px 24px;">
        <div class="table-responsive">
            <table class="table table-bordered table-striped text-center mt-3">
                <thead>
                    <tr>
                        <th>Organisasi</th>
                        <th>Tahun</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Status</th>
                        <th>Jam Kerja Biasa</th>
                        <th>Jam Kerja Ramadhan</th>
                        <th>Aksi</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="datas.length === 0">
                        <td colspan="8" class="text-center">{{errorMessage || 'Tidak ada data'}}</td>
                    </tr>
                    <tr v-for="(item, index) in datas" :key="index">
                        <td>{{item.organisasi}}</td>
                        <td>{{item.tahun}}</td>
                        <td>{{item.startdate}}</td>
                        <td>{{item.enddate}}</td>
                        <td>
                            <CBadge :color="item.isActive ? 'success' : 'secondary'">
                                {{item.isActive ? 'Aktif' : 'Tidak Aktif'}}
                            </CBadge>
                        </td>
                        <td>{{item.kodeJamKerjaBisa}}</td>
                        <td>{{item.kodeJamKerjaRamadhan}}</td>
                        <td>
                            <CButton color="info" size="sm" @click="openModalEdit(item)">Edit</CButton>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Modal Form -->
    <CModal
      :show.sync="showModal"
      :closeOnBackdrop="false"
      size="lg"
      :title="modalTitle"
    >
        <template #header>
            <h5 class="modal-title">{{ modalTitle }}</h5>
            <button type="button" class="close" @click="showModal = false">&times;</button>
        </template>
        
        <CRow class="mb-3">
            <CCol sm="6">
                <label>Organisasi</label>
                <input type="text" class="form-control" v-model="form.organisasi" placeholder="Masukkan Organisasi"/>
            </CCol>
            <CCol sm="6">
                <label>Tahun</label>
                <input type="number" class="form-control" v-model.number="form.tahun" placeholder="Contoh: 2026"/>
            </CCol>
        </CRow>
        <CRow class="mb-3">
            <CCol sm="12">
                <label>Deskripsi</label>
                <input type="text" class="form-control" v-model="form.deskripsi" placeholder="Masukkan Deskripsi"/>
            </CCol>
        </CRow>
        <CRow class="mb-3">
            <CCol sm="6">
                <label>Start Date</label>
                <input type="date" class="form-control" v-model="form.startdate"/>
            </CCol>
            <CCol sm="6">
                <label>End Date</label>
                <input type="date" class="form-control" v-model="form.enddate"/>
            </CCol>
        </CRow>
        <CRow class="mb-3">
            <CCol sm="6">
                <label>Jam Kerja Biasa</label>
                <select class="form-control" v-model="form.kodeJamKerjaBisa">
                    <option value="">Pilih Jam Kerja</option>
                    <option v-for="jk in listJamKerja" :key="jk.kode" :value="jk.kode">{{jk.kode}} - {{jk.deskripsi}}</option>
                </select>
            </CCol>
            <CCol sm="6">
                <label>Jam Kerja Ramadhan</label>
                <select class="form-control" v-model="form.kodeJamKerjaRamadhan">
                    <option value="">Pilih Jam Kerja</option>
                    <option v-for="jk in listJamKerja" :key="'r_'+jk.kode" :value="jk.kode">{{jk.kode}} - {{jk.deskripsi}}</option>
                </select>
            </CCol>
        </CRow>
        <CRow class="mb-3">
            <CCol sm="6">
                <label>Status Aktif</label>
                <select class="form-control" v-model="form.isActive">
                    <option :value="true">Aktif</option>
                    <option :value="false">Tidak Aktif</option>
                </select>
            </CCol>
        </CRow>

        <template #footer>
            <CButton color="secondary" @click="showModal = false">Batal</CButton>
            <CButton color="primary" @click="simpanData()" :disabled="loadingSave">
                {{ loadingSave ? 'Menyimpan...' : 'Simpan' }}
            </CButton>
        </template>
    </CModal>
</div>
</template>

<script>
import {DataApi} from "../service/DataApi";

export default {
    name: 'AbsensBulanRamadhan',
    data() {
        return {
            refreshIcon: require('../assets/menu/icon_refresh.svg'),
            classReload: 'reloadOff',
            datas: [],
            listJamKerja: [],
            
            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            filter: {
                organisasi: '',
                tahun: ''
            },
            flagSearch: false,

            // error
            errorMessage: 'Find Your Data',

            // Modal
            showModal: false,
            modalTitle: '',
            loadingSave: false,
            form: {
                id: null,
                organisasi: '',
                tahun: '',
                startdate: '',
                enddate: '',
                deskripsi: '',
                kodeJamKerjaBisa: '',
                kodeJamKerjaRamadhan: '',
                isActive: true
            }
        }
    },
    watch: {
        page() {
            window.scroll({ top:0, left: 0, behavior: 'smooth' });
        },
        'filter.organisasi'() { this.flagSearch = true },
        'filter.tahun'() { this.flagSearch = true }
    },
    methods: {
        getJamKerja() {
            DataApi.post("konfigurasi/jam-kerja", {})
            .then(res => {
                if(res.data.success) {
                    this.listJamKerja = res.data.data;
                }
            }).catch(err => console.log(err))
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            
            let payload = {
                limit: this.size,
                pageIn: this.page,
                organisasi: this.filter.organisasi || null,
                tahun: this.filter.tahun ? parseInt(this.filter.tahun) : null
            }
            
            DataApi.post("konfigurasi/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data || response.data || []
                    this.totalRow = response.data.totalRow || this.datas.length
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    if(this.totalRow % this.size != 0) {
                        this.totalPage += 1
                    }
                    if(this.totalPage == 0) this.totalPage = 1;
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message || 'Data tidak ditemukan'
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            }).catch(() => {
                this.$store.state.loadingScreen = false
                this.datas = []
                this.errorMessage = 'Terjadi kesalahan pada server'
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.filter = { organisasi: '', tahun: '' }
            this.flagSearch = true
            this.getData()
            this.classReload = this.classReload == 'reloadOff' ? 'reloadOn' : 'reloadOff'
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        resetForm() {
            this.form = {
                id: null,
                organisasi: '',
                tahun: '',
                startdate: '',
                enddate: '',
                deskripsi: '',
                kodeJamKerjaBisa: '',
                kodeJamKerjaRamadhan: '',
                isActive: true
            }
        },
        openModalAdd() {
            this.resetForm()
            this.modalTitle = 'Tambah Konfigurasi'
            this.showModal = true
        },
        openModalEdit(item) {
            this.resetForm()
            this.modalTitle = 'Ubah Konfigurasi'
            this.form = {
                id: item.id,
                organisasi: item.organisasi,
                tahun: item.tahun,
                startdate: item.startdate,
                enddate: item.enddate,
                deskripsi: item.deskripsi,
                kodeJamKerjaBisa: item.kodeJamKerjaBisa,
                kodeJamKerjaRamadhan: item.kodeJamKerjaRamadhan,
                isActive: item.isActive
            }
            this.showModal = true
        },
        simpanData() {
            this.loadingSave = true
            let payload = {
                ...this.form,
                tahun: parseInt(this.form.tahun)
            }
            if(!payload.id) {
                delete payload.id // For ADD, ID must be null/empty
            }
            
            DataApi.post("konfigurasi/simpan", payload)
            .then(res => {
                this.loadingSave = false
                if(res.data.success) {
                    this.showModal = false
                    this.reload()
                } else {
                    alert(res.data.message || 'Gagal menyimpan data')
                }
            }).catch(err => {
                this.loadingSave = false
                alert('Terjadi kesalahan')
            })
        }
    },
    mounted() {
        this.getJamKerja()
        this.getData()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.inputs-form {
    width: 100%;
    background-color: rgba(249, 250, 252, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding: 12px 24px;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding: 12px 24px;
    background-color: white;
    z-index: 1;
}
input, select {
    background-color: rgba(249, 250, 252, 1);
}
</style>
